/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  CreateUpdateEnumerationQuantityDto,
  EnumerationQuantityDto,
  HistoryDto,
  ODataPostProcessedResultsOfEnumerationQuantityDto,
  ProblemDetails,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    CreateUpdateEnumerationQuantityDtoFromJSON,
    CreateUpdateEnumerationQuantityDtoToJSON,
    EnumerationQuantityDtoFromJSON,
    EnumerationQuantityDtoToJSON,
    HistoryDtoFromJSON,
    HistoryDtoToJSON,
    ODataPostProcessedResultsOfEnumerationQuantityDtoFromJSON,
    ODataPostProcessedResultsOfEnumerationQuantityDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface CreateEnumerationQuantityRequest {
    createUpdateEnumerationQuantityDto?: CreateUpdateEnumerationQuantityDto;
}

export interface DeleteEnumerationQuantityRequest {
    id: string;
}

export interface GetEnumerationHistoryRequest {
    id: string;
}

export interface GetEnumerationQuantityRequest {
    id: string;
}

export interface GetEnumerationQuantityListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface UpdateEnumerationQuantityRequest {
    id: string;
    createUpdateEnumerationQuantityDto?: CreateUpdateEnumerationQuantityDto;
}

export interface ValidateEnumerationQuantityRequest {
    createUpdateEnumerationQuantityDto?: CreateUpdateEnumerationQuantityDto;
}

/**
 * 
 */
export class EnumerationQuantitiesApi extends runtime.BaseAPI {

    /**
     * Adds a new entity
     */
    async createEnumerationQuantityRaw(requestParameters: CreateEnumerationQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnumerationQuantityDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/enumeration-quantities`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateEnumerationQuantityDtoToJSON(requestParameters.createUpdateEnumerationQuantityDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => EnumerationQuantityDtoFromJSON(jsonValue));
    }

    /**
     * Adds a new entity
     */
    async createEnumerationQuantity(requestParameters: CreateEnumerationQuantityRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.createEnumerationQuantityRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<EnumerationQuantityDto>(response, errorHandlers);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteEnumerationQuantityRaw(requestParameters: DeleteEnumerationQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteEnumerationQuantity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/enumeration-quantities/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteEnumerationQuantity(requestParameters: DeleteEnumerationQuantityRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deleteEnumerationQuantityRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async getEnumerationHistoryRaw(requestParameters: GetEnumerationHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HistoryDto>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getEnumerationHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/enumeration-quantities/{id}/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON));
    }

    /**
     */
    async getEnumerationHistory(requestParameters: GetEnumerationHistoryRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getEnumerationHistoryRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<HistoryDto>>(response, errorHandlers);
    }

    /**
     * Returns one entity for detail view.
     */
    async getEnumerationQuantityRaw(requestParameters: GetEnumerationQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnumerationQuantityDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getEnumerationQuantity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/enumeration-quantities/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => EnumerationQuantityDtoFromJSON(jsonValue));
    }

    /**
     * Returns one entity for detail view.
     */
    async getEnumerationQuantity(requestParameters: GetEnumerationQuantityRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getEnumerationQuantityRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<EnumerationQuantityDto>(response, errorHandlers);
    }

    /**
     */
    async getEnumerationQuantityCatalogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EnumerationQuantityDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/enumeration-quantities/catalog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EnumerationQuantityDtoFromJSON));
    }

    /**
     */
    async getEnumerationQuantityCatalog(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getEnumerationQuantityCatalogRaw(initOverrides);
        return this.configuration.handleFunction<Array<EnumerationQuantityDto>>(response, errorHandlers);
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getEnumerationQuantityListRaw(requestParameters: GetEnumerationQuantityListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfEnumerationQuantityDto>> {
        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/enumeration-quantities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfEnumerationQuantityDtoFromJSON(jsonValue));
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getEnumerationQuantityList(requestParameters: GetEnumerationQuantityListRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getEnumerationQuantityListRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfEnumerationQuantityDto>(response, errorHandlers);
    }

    /**
     * Updates an entity, if existing
     */
    async updateEnumerationQuantityRaw(requestParameters: UpdateEnumerationQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnumerationQuantityDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateEnumerationQuantity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/enumeration-quantities/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateEnumerationQuantityDtoToJSON(requestParameters.createUpdateEnumerationQuantityDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => EnumerationQuantityDtoFromJSON(jsonValue));
    }

    /**
     * Updates an entity, if existing
     */
    async updateEnumerationQuantity(requestParameters: UpdateEnumerationQuantityRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateEnumerationQuantityRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<EnumerationQuantityDto>(response, errorHandlers);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateEnumerationQuantityRaw(requestParameters: ValidateEnumerationQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/enumeration-quantities/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateEnumerationQuantityDtoToJSON(requestParameters.createUpdateEnumerationQuantityDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateEnumerationQuantity(requestParameters: ValidateEnumerationQuantityRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateEnumerationQuantityRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
